<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
          <v-toolbar dense color="transparent" flat>
            <v-btn small text :color="isActive.bold() ? 'primary' : 'grey'" @click="commands.bold">
              <v-icon>mdi-format-bold</v-icon>
            </v-btn>
            <v-btn small text :color="isActive.italic() ? 'primary' : 'grey'" @click="commands.italic">
              <v-icon>mdi-format-italic</v-icon>
            </v-btn>
            <v-btn small text :color="isActive.underline() ? 'primary' : 'grey'" @click="commands.underline">
              <v-icon>mdi-format-underline</v-icon>
            </v-btn>
            <v-btn small text :color="isActive.strike() ? 'primary' : 'grey'" @click="commands.strike">
              <v-icon>mdi-format-strikethrough</v-icon>
            </v-btn>
            <v-btn small text :color="isActive.heading({ level: 1 }) ? 'primary' : 'grey'" @click="commands.heading({ level: 1 })">
              <v-icon>mdi-format-header-1</v-icon>
            </v-btn>
            <v-btn small text :color="isActive.heading({ level: 2 }) ? 'primary' : 'grey'" @click="commands.heading({ level: 2 })">
              <v-icon>mdi-format-header-2</v-icon>
            </v-btn>
            <v-btn small text :color="isActive.heading({ level: 3 }) ? 'primary' : 'grey'" @click="commands.heading({ level: 3 })">
              <v-icon>mdi-format-header-3</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn small text @click="commands.undo" color="primary">
              <v-icon>mdi-undo</v-icon>
            </v-btn>
            <v-btn small text @click="commands.redo" color="primary">
              <v-icon>mdi-redo</v-icon>
            </v-btn>
            <v-btn small rounded @click="save" color="primary">
              {{$t('Global.Action.save')}}
            </v-btn>
          </v-toolbar>
        </editor-menu-bar>
        <editor-content :editor="editor"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import { Heading, HardBreak, Bold, Italic, Underline, Link, Strike, History } from 'tiptap-extensions'
export default {
  name: 'MallEditorial',
  components: { EditorContent, EditorMenuBar },
  props: {
    content: {type: String, required: false, default: ''}
  },
  data: () => ({
    editor: new Editor({
      content: '',
      extensions: [
        new Heading(),
        new HardBreak(),
        new Bold(),
        new Italic(),
        new Underline(),
        new Link(),
        new Strike(),
        new History()
      ],
    })
  }),
  watch: {
    content: {
      immediate: true,
      handler (value) {
        this.editor.setContent(value)
      }
    }
  },
  methods: {
    save () {
      this.$emit('save', this.editor.getHTML())
    }
  },
  beforeDestroy() {
    // Always destroy your editor instance when it's no longer needed
    this.editor.destroy()
  }
}
</script>